import { render, staticRenderFns } from "./IssueOption.vue?vue&type=template&id=3ab66078&scoped=true"
import script from "./IssueOption.vue?vue&type=script&lang=js"
export * from "./IssueOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab66078",
  null
  
)

export default component.exports